import { Component, input } from '@angular/core';
import { StoreVop } from 'projects/max/dfup-storeupweb-fe/src/app/page/store-vops/store-vops.component';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-store-tile',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './store-tile.component.html',
  styleUrl: './store-tile.component.scss'
})
export class StoreTileComponent {
  store = input.required<StoreVop>();
}
